import { Button, Form, InputDate, InputField } from "@sellar-io/components";
import dayjs from "dayjs";
import { ReactElement, useState } from "react";
import { Alert } from "../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useOrderFinalize } from "../../../hooks/api/v2/order/useOrderFinalize";

export const OrderSendInvoiceModal = ({
  onDismiss,
  active,
  paymentDue,
  buyerName,
  orderId,
  onSuccess,
}: {
  onDismiss: () => void;
  active: boolean;
  orderId: number;
  buyerName: string;
  paymentDue: Date | null;
  onSuccess?: () => void;
}): ReactElement => {
  const [paymentDueDate, setPaymentDueDate] = useState<Date | null>(paymentDue);
  const [previousPaymentDue, setPreviousPaymentDue] = useState(paymentDue);
  if (paymentDue !== previousPaymentDue) {
    setPreviousPaymentDue(paymentDue);
    setPaymentDueDate(paymentDue ? dayjs(paymentDue).toDate() : null);
  }
  const orderFinalizeMutation = useOrderFinalize(orderId);

  const handleSubmit = () => {
    if (paymentDueDate) {
      orderFinalizeMutation.mutate(
        {
          paymentDue: dayjs(paymentDueDate).toDate(),
        },
        {
          onSuccess: () => {
            onSuccess?.();
            onDismiss();
          },
        },
      );
    }
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        onClickLeftIcon={onDismiss}
        leftIcon={"CHEVRON_DOWN"}
        title={"Finalise and send invoice"}
        description={`This will finalise the invoice on Stripe and ${buyerName} will receive a link to make a payment via credit or debit card.`}
      />
      <DialogContent className={"p-4"}>
        {orderFinalizeMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(orderFinalizeMutation.error)?.response?.data
                .message ?? "An unknown error occurred"
            }
          />
        )}
        <Form className="flex w-full flex-col" onSubmit={handleSubmit}>
          <InputField label={"Payment due date"}>
            <InputDate
              required={true}
              name={"paymentDueDate"}
              value={
                paymentDueDate || paymentDue
                  ? dayjs(paymentDueDate ?? paymentDue).format("YYYY-MM-DD")
                  : ""
              }
              onChange={(e) => {
                setPaymentDueDate(dayjs(e.target.valueAsNumber).toDate());
              }}
              min={dayjs().add(1, "day").startOf("day").format("YYYY-MM-DD")}
            />
          </InputField>
          <DialogCTA>
            <Button type={"submit"} loading={orderFinalizeMutation.isPending}>
              Confirm
            </Button>
          </DialogCTA>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
